import React, { memo } from 'react';
import { object, array } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';
import { getYearFormat } from 'utils/formatDataHelper';

import styles from './AutosuggestModelItem.module.scss';
const cx = classNames.bind(styles);

const AutosuggestModelItem = ({ suggestion, manufactures }) => (
  <span className={cx('suggestion-content')}>
    <span className={cx('name')}>
      {manufactures.map((part, index) => {
        const className = part.highlight ? 'highlight' : null;

        return (
          <span className={className} key={index}>
            {part.text}
          </span>
        );
      })}
    </span>

    <span className={cx('car-years')}>
      {suggestion.yearOfConstrFrom && (
        <span className={cx('item')}>
          {getYearFormat(suggestion.yearOfConstrFrom)}
        </span>
      )}
      <span className={cx('separator')}>&nbsp;-&nbsp;</span>
      {suggestion.yearOfConstrTo && (
        <span className={cx('item')}>
          {getYearFormat(suggestion.yearOfConstrTo)}
        </span>
      )}
    </span>
  </span>
);

AutosuggestModelItem.propTypes = {
  suggestion: object.isRequired,
  manufactures: array.isRequired,
};

export default memo(withLabels(withErrorBoundary(AutosuggestModelItem)));



// WEBPACK FOOTER //
// ./src/components/AutosuggestModel/components/AutosuggestModelItem/AutosuggestModelItem.js